export default "__VITE_PUBLIC_ASSET__76cbf0e9__"